export const ROLES = {
    Admin: 'Admin',
    Manager: 'Manager',
    Employee: 'Employee'
}